import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import DateSince from 'components/DateSince';
import { useHistory } from 'react-router-dom';
import DocsAssignModal from '../DocsAssignModal/DocsAssignModal';

const DocsTask = ({ className, task }) => {
  let history = useHistory();

  const [showAssignOwner, setShowAssignOwner] = useState(false);

  const redirectToDetail = useCallback(() => {
    history.push(`/docs/${task.id}`);
  }, [history, task.id]);

  const handleNameClick = useCallback(
    (event) => {
      event.stopPropagation();
      setShowAssignOwner(!showAssignOwner);
    },
    [showAssignOwner]
  );

  const handleCloseModal = useCallback(() => {
    setShowAssignOwner(false);
  }, [setShowAssignOwner]);

  return (
    <div className={className} key={task.id} onClick={redirectToDetail} data-testid="docs-task">
      <div className="docs-task">
        <div className="docs-task__header">
          <span className="docs-task__title">{task.entity?.name}</span>
          <span className="docs-task__owner" data-testid="owner-button" onClick={handleNameClick}>
            {task.entity?.document_owner || 'No owner'}
          </span>
        </div>
        <div
          className="docs-task__modal-container"
          onClick={(e) => e.stopPropagation()}
          data-testid="owner-modal-container"
        >
          <DocsAssignModal
            show={showAssignOwner}
            docId={task.id}
            carrierId={task.entity?.carrier_uuid}
            onClose={handleCloseModal}
          />
        </div>
        <div className="docs-task__body">
          <span className="docs-task__item">{task.document_type?.label}</span>
          <span className="docs-task__date">
            <DateSince date={task.date_added} />
          </span>
        </div>
      </div>
    </div>
  );
};

DocsTask.defaultProps = {
  className: '',
  task: null,
};

DocsTask.propTypes = {
  className: PropTypes.string,
  task: PropTypes.object,
};

export default DocsTask;
